import * as React from 'react';

export function SvgChevronUp() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="-2 -2 16 16">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M6 4.06 2.03 8.03.97 6.97l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5-1.06 1.06z"
          clipRule="evenodd"
        />
      </svg>
    </span>
  );
}
